import { RobotInfo } from '@whelk/services/src/type/chat';

export const IMAGE_TYPE_LIST = ['png', 'jpeg', 'jpg', 'webp', 'svg', 'heif', 'tiff'];

export const FILE_TYPE_LIST = ['txt', 'docx', 'doc', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx'];

export const MAIN_ROBOT_INFO: RobotInfo = {
  robotID: 1,
  name: 'MiniMax AI',
  avatarInfo: {
    small:
      'https://cdn.yingshi-ai.com/prod/2024-03-27-17/robot_avatar/1711530887770317113-1small.png',
    medium:
      'https://cdn.yingshi-ai.com/prod/2024-03-27-17/robot_avatar/1711530887772114034-1medium.png',
    large:
      'https://cdn.yingshi-ai.com/prod/2024-03-27-17/robot_avatar/1711530887769521226-1large.png',
    oversize:
      'https://cdn.yingshi-ai.com/prod/2024-03-27-17/robot_avatar/1711530887770861428-1oversize.png',
  },
  status: 2,

  canShareChat: true,
  supportMultimodal: [
    {
      name: '图片',
      formType: 2,
      fileType: IMAGE_TYPE_LIST,
      content: '',
    },
    {
      name: '文件',
      formType: 6,
      fileType: FILE_TYPE_LIST,
      content: '',
    },
  ],
  robotIDStr: '1',
  showType: 1,
  canSearch: true,
  canPopupVoiceWindow: false,
};

export const ALL_TYPE_TO_UPPER_CASE = [...FILE_TYPE_LIST, ...IMAGE_TYPE_LIST]
  .map((s) => s.toUpperCase())
  .join('，');

export const ALL_TYPE_LIST = [...FILE_TYPE_LIST, ...IMAGE_TYPE_LIST];
